import { Tool } from './base';

export class CrowdStrikeTool extends Tool {
  public readonly toolName = 'CrowdStrike';

  public generateSearchPermalink(
    rootURL: string,
    renderedContent: string
  ): string {
    const encodedRenderedContent = encodeURIComponent(renderedContent);
    return `${rootURL}investigate/events/en-US/app/eam2/search?q=${encodedRenderedContent}`;
  }
}
